import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material'

import Chip from '@/components/Chip'
import { getEnamelLayerAdvice } from '@/utils/matisseV2/allInOne'

interface SkinEnamelProps {
  brand?: string
  isAnalogRecipe?: boolean
  recipeOutput?: any
  enamellayer_advice?: {
    enamel_cervical?: string
    enamel_middle?: string
    enamel_incisal?: string
  }
}

const SkinEnamel: React.FC<SkinEnamelProps> = ({
  brand,
  isAnalogRecipe = false,
  recipeOutput,
  enamellayer_advice,
}) => {
  const enamelValue = (region: 'cervical' | 'middle' | 'incisal') =>
    getEnamelLayerAdvice(recipeOutput, region) ??
    enamellayer_advice?.[`enamel_${region}`]
  const theme = useTheme()
  return (
    <Box
      sx={{
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        background: '#292929',
        p: 4,
      }}
    >
      {/* Title */}
      <Box display="flex" alignItems="center" pb={3} gap={1}>
        <Typography
          sx={{ fontSize: '1rem', fontWeight: 200, lineHeight: '20px' }}
        >
          {isAnalogRecipe ? 'Enamel:' : 'Skin Enamel:'}
        </Typography>
        <Chip
          label={brand}
          sx={{
            bgcolor: theme.palette.background.chip,
            color: theme.palette.common.black,
            '&:hover': {
              bgcolor: theme.palette.background.chip,
            },
          }}
          size="small"
        />
      </Box>

      {/* Table */}
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{ fontWeight: 500, fontSize: '14px', lineHeight: '24px' }}
              >
                Head
              </TableCell>
              <TableCell
                sx={{ fontWeight: 500, fontSize: '14px', lineHeight: '24px' }}
              >
                Cervical
              </TableCell>
              <TableCell
                sx={{ fontWeight: 500, fontSize: '14px', lineHeight: '24px' }}
              >
                Middle
              </TableCell>
              <TableCell
                sx={{ fontWeight: 500, fontSize: '14px', lineHeight: '24px' }}
              >
                Incisal
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell
                sx={{ fontWeight: 500, fontSize: '14px', lineHeight: '24px' }}
              >
                Enamel
              </TableCell>
              <TableCell>{enamelValue('cervical') || '-'}</TableCell>
              <TableCell>{enamelValue('middle') || '-'}</TableCell>
              <TableCell>{enamelValue('incisal') || '-'}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default SkinEnamel
